import axios from "axios";

// const API_URL = "https://80f3-27-107-210-194.ngrok-free.app/api";
// const headers = { "ngrok-skip-browser-warning": "69420" };

// export const API_URL = "https://4b39-27-107-210-194.ngrok-free.app/api/items";
export const API_URL = "https://alopexia.com/service/api/items";
const headers = { "ngrok-skip-browser-warning": "69420" };

export const customerRegister = `${API_URL}/register`
export const customerLogin = `${API_URL}/login`
export const updaterProfile = `${API_URL}/updateProfile`
export const getProfile = `${API_URL}/getProfile`
export const firstUserAddAddress = `${API_URL}/addAddress` //First Time LoggedIn user Add Address
export const updateUserDefaultAddress = `${API_URL}/updateCustomerDefaultAddress` //updateCustomerDefaultAddress


export const healthAssesmentForm = `https://aloxa.ai/flaskservice/add_medical_history`
export const uploadDocument = `https://aloxa.ai/flaskservice/upload_document`
export const updateShopifyDetails ="https://aloxa.ai/flaskservice/update_shopify_details"


// export const customerLogin = async (email, password) => {
//   const response = await axios.post(`${API_URL}/login`, {
//     email, 
//     password
//   });
//   return response;
// };


// 1. Get all products
export const getAllProducts = async () => {
  const response = await axios.get(`${API_URL}/getProducts`, { headers });
  console.log(response, "::>>getAllProducts");
  return response.data.products;
};

// 2. Add to cart
export const addToCart = async (productId, variantId, quantity = 1) => {
  const response = await axios.post(`${API_URL}/addTocart`, {
    productId,
    variantId,
    quantity,
  });
  return response.data.cart;
};

// 3. Get cart products
export const getCartProducts = async () => {
  const response = await axios.get(`${API_URL}/getCart`, { headers });
  return response.data.cart;
};

// const API_URL = "http://localhost:3000/api";
// 4. Checkout
export const checkout = async () => {
  const response = await axios.post(`${API_URL}/createCheckout`);
  console.log(response, "::>>checkoutresponse");
  return response.data.checkoutUrl;
};

// 5. Buy products (Place order)
export const buyProducts = async () => {
  const response = await axios.post(`${API_URL}/buy`);
  return response.data.order;
};

// 6. Payment (Mock)
export const makePayment = async () => {
  const response = await axios.post(`${API_URL}/payment`);
  return response.data.message;
};

//7.  Remove product from cart
export const removeFromCart = async (productId) => {
  const response = await axios.delete(`${API_URL}/removeProduct/${productId}`);
  return response.data.cart;
};

//8. Update Cart Quantity
export const updateCartQuantity = async (productId, quantity) => {
  try {
    const response = await axios.put(`${API_URL}/updateCartQuantity/${productId}`, { quantity });
    return response.data.cart; // Returns the updated cart
  } catch (error) {
    console.error('Error updating cart quantity:', error);
    throw error; // You can handle the error further based on your needs
  }
};



// <! ------------------------------------- API Backup----------------------------------------- !>

// import axios from "axios";

// const API_URL = "https://80f3-27-107-210-194.ngrok-free.app/api";
// const headers = { "ngrok-skip-browser-warning": "69420" };

// export const customerLogin = async (email, password) => {
//   const response = await axios.post(`${API_URL}/login`, {
//     email, 
//     password
//   });
//   return response;
// };


// // 1. Get all products
// export const getAllProducts = async () => {
//   const response = await axios.get(`${API_URL}/products`, { headers });
//   console.log(response, "::>>getAllProducts");
//   return response.data.products;
// };

// // 2. Add to cart
// export const addToCart = async (productId, variantId, quantity = 1) => {
//   const response = await axios.post(`${API_URL}/cart`, {
//     productId,
//     variantId,
//     quantity,
//   });
//   return response.data.cart;
// };

// // 3. Get cart products
// export const getCartProducts = async () => {
//   const response = await axios.get(`${API_URL}/cart`, { headers });
//   return response.data.cart;
// };

// // const API_URL = "http://localhost:3000/api";
// // 4. Checkout
// export const checkout = async () => {
//   const response = await axios.post(`${API_URL}/checkout`);
//   console.log(response, "::>>checkoutresponse");
//   return response.data.checkoutUrl;
// };

// // 5. Buy products (Place order)
// export const buyProducts = async () => {
//   const response = await axios.post(`${API_URL}/buy`);
//   return response.data.order;
// };

// // 6. Payment (Mock)
// export const makePayment = async () => {
//   const response = await axios.post(`${API_URL}/payment`);
//   return response.data.message;
// };

// //7.  Remove product from cart
// export const removeFromCart = async (productId) => {
//   const response = await axios.delete(`${API_URL}/cart/${productId}`);
//   return response.data.cart;
// };

// //8. Update Cart Quantity
// export const updateCartQuantity = async (productId, quantity) => {
//   try {
//     const response = await axios.put(`${API_URL}/cart/${productId}`, { quantity });
//     return response.data.cart; // Returns the updated cart
//   } catch (error) {
//     console.error('Error updating cart quantity:', error);
//     throw error; // You can handle the error further based on your needs
//   }
// };



